import { render, staticRenderFns } from "./_ImageAttachment.vue?vue&type=template&id=0fe5358e"
import script from "./_ImageAttachment.vue?vue&type=script&lang=js"
export * from "./_ImageAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports